/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ScannerProfile } from './ScannerProfile';
import type { SlideClassificationSimple } from './SlideClassificationSimple';
import type { SlideFlag } from './SlideFlag';

export type CaseSlide = {
    readonly id?: number;
    readonly case_id?: number;
    readonly lab_id?: number;
    /**
     * original filename of the slide from the scanner
     */
    name?: string | null;
    readonly created_at?: string;
    /**
     * status of a slide until it's fully imported and visible to a user in 'success'. History logged by SlideStatusChange.
     */
    status?: CaseSlide.status;
    /**
     * slide number in the provided block
     */
    slide_number?: string | null;
    readonly stain_id?: number;
    readonly specimen_id?: number;
    readonly block_obj_id?: number;
    readonly classifications?: Array<SlideClassificationSimple>;
    readonly was_previously_viewed?: boolean;
    flags: Array<SlideFlag>;
    is_rescan?: boolean;
    is_control?: boolean;
    readonly slide_rotation_degrees?: number;
    /**
     * Full URL in cloudfront where the slide's full (0-40x+) pre-computed tile "manifest" has been stored. If this is populated the viewer should load all of a slide's tiles from paths provided via the manifest file, indicating no tile server use.
     */
    full_precompute_location?: string | null;
    readonly thumbnail?: string;
    readonly scanner?: ScannerProfile;
    /**
     * type of slide: brightfield or fluorescence
     */
    slide_type?: CaseSlide.slide_type;
    readonly lab_order_id?: number;
}

export namespace CaseSlide {

    /**
     * status of a slide until it's fully imported and visible to a user in 'success'. History logged by SlideStatusChange.
     */
    export enum status {
        RECEIVED_WPL = 'received-wpl',
        RECEIVED_LAB = 'received-lab',
        PENDING = 'pending',
        PRECOMPUTING = 'precomputing',
        UPLOADED = 'uploaded',
        ERROR = 'error',
        MANUAL_MERGE = 'manual-merge',
        MANUAL_REVIEW = 'manual-review',
        SUCCESS = 'success',
        PENDING_AI = 'pending-ai',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        ON_HOLD = 'on-hold',
        PROCESSING = 'processing',
    }

    /**
     * type of slide: brightfield or fluorescence
     */
    export enum slide_type {
        BRIGHTFIELD = 'brightfield',
        FLUORESCENCE = 'fluorescence',
    }


}
